import React, {PropsWithChildren, useEffect, useRef, useState} from 'react';

interface LeaderboardDropdownProps {
    trigger: JSX.Element;
}

function LeaderboardDropdown({trigger, children}: PropsWithChildren<LeaderboardDropdownProps>): JSX.Element {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!open) return undefined;

        const closeOnOutside = (event: Event): void => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setOpen(false);
            }
        };
        const closeOnEscape = (event: KeyboardEvent): void => {
            if (event.key === 'Escape') setOpen(false);
        };

        document.addEventListener('mousedown', closeOnOutside);
        document.addEventListener('touchstart', closeOnOutside);
        document.addEventListener('keydown', closeOnEscape);

        return () => {
            document.removeEventListener('mousedown', closeOnOutside);
            document.removeEventListener('touchstart', closeOnOutside);
            document.removeEventListener('keydown', closeOnEscape);
        };
    }, [open]);

    return (
        <div ref={wrapperRef} className="c-leaderboardDropdown">
            <div className="c-leaderboardDropdown__trigger" onClick={() => setOpen((prev) => !prev)}>
                {trigger}
            </div>
            {open && <div className="c-leaderboardDropdown__menu">{children}</div>}
        </div>
    );
}

export default LeaderboardDropdown;
